import translateBase from '../translate';
let translate = translateBase.bindComponent('validations');

function nonEmpty(value) {
  if(typeof value !== 'string' || value.length === 0) {
    return [translate('cannotBeEmpty', "This field cannot be empty.")];
  } else {
    return [];
  }
}

function validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
}

export class Validator {

  salutation(value) {
    let errors = [];
    errors = errors.concat(nonEmpty(value));
    return errors;
  }

  firstName(value) {
    let errors = [];
    errors = errors.concat(nonEmpty(value));
    return errors;
  }

  lastName(value) {
    let errors = [];
    errors = errors.concat(nonEmpty(value));
    return errors;
  }   

  email(value) {
    let errors = [];
    errors = errors.concat(nonEmpty(value));
    if(!validateEmail(value)) {
      errors.push(translate('notAnEmail', 'Provided value is not a valid email address.'));
    }
    return errors;
  }

  phone(value) {
    let errors = [];
    //errors = errors.concat(nonEmpty(value));
    return errors;
  }
  
  mobilePhone = this.phone;
  faxPhone = this.phone;
  
  userName(value) {
    let errors = [];
    errors = errors.concat(nonEmpty(value));
    return errors;
  }

  password1(value) {
    let errors = [];
    //errors = errors.concat(nonEmpty(value));
    if(!value || value.length < 7) {
      errors.push(translate('passwordLength', "The password must be minimum ${charNo} characters with at least one lowercase character and one special character.", {charNo: 7}));
    }
    return errors;
  }

  password2 = this.password1;
  oldPassword = this.password1;

  timeZone(value) {
    let errors = [];
    errors = errors.concat(nonEmpty(value));
    return errors;
  }  

  language(value) {
    let errors = [];
    errors = errors.concat(nonEmpty(value));
    return errors;
  }  

  street(value) {
    let errors = [];
    errors = errors.concat(nonEmpty(value));
    return errors;
  }

  addition(value) {
    let errors = [];
    //errors = errors.concat(nonEmpty(value));
    return errors;
  }

  postalCode(value) {
    let errors = [];
    errors = errors.concat(nonEmpty(value));
    return errors;
  }  

  city(value) {
    let errors = [];
    errors = errors.concat(nonEmpty(value));
    return errors;
  } 
  
  country(value) {
    let errors = [];
    errors = errors.concat(nonEmpty(value));
    return errors;
  }  
}


// WEBPACK FOOTER //
// ./src/model/Validator.js